import React from 'react';

import { LoadablePaint } from '@confluence/loadable';

const MobileAppTakeoverPageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MobileAppTakeoverPage" */ '@confluence/mobile-web/entry-points/MobileAppTakeoverPage.js'
			)
		).MobileAppTakeoverPage,
});

export const MobileTakeoverPageRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: boolean;
	};
} = (): React.JSX.Element => <MobileAppTakeoverPageLoader />;

MobileTakeoverPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'mobileTakeoverPage',
		},
	},
	MainLayout: false,
});
